function CookiePage() {
  function getSubmitButton() {
    return document.querySelector(`button[data-cookie-action="saveChoices"]`);
  }

  function setCheckboxesChecked(checked) {
    const checkboxes = document.querySelectorAll(
      `input[type="checkbox"]:not([required])`,
    );
    checkboxes.forEach((checkbox) => {
      checkbox.checked = checked;
    });
  }

  const cookieDialog = document.querySelector('[data-show-dialog="cookie"]');
  if (cookieDialog) {
    cookieDialog.showModal();
  }

  document.addEventListener("click", (e) => {
    const target = e.target;

    if (!(target instanceof HTMLButtonElement)) {
      return;
    }

    if (target.dataset.cookieAction == "acceptNecessary") {
      setCheckboxesChecked(false);
      getSubmitButton()?.click();
    }

    if (target.dataset.cookieAction == "acceptAll") {
      setCheckboxesChecked(true);
      getSubmitButton()?.click();
    }
  });
}
CookiePage();

export default CookiePage;
